// custom typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'
import 'typeface-roboto'

import 'prismjs/themes/prism.css'

//redux
import wrapWithProvider from './wrap-with-provider'
export const wrapRootElement = wrapWithProvider
